import { CSSProperties } from 'react';

import styled from 'styled-components';

import {
  LANDING_BREAKPOINT,
  LARGE_SCREEN_BREAKPOINT,
} from '@utils/theme/breakPoint';
import { PaletteColor } from '@utils/types';

export const BookerHr = styled.hr<{ isTravelPlanning?: boolean }>`
  display: ${({ isTravelPlanning }) => (isTravelPlanning ? 'none' : 'flex')};
  width: 100%;
  border-top: unset;
  margin: 0 auto;
  border: 0;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    width: 90%;
    border: 0;
    border-top: 1px solid rgba(41, 42, 44, 0.15);
  }
`;

export const ClearSearchButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 3;
  display: flex;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding-right: 5px;
  em {
    display: none;
  }
  &:hover {
    background-color: rgba(250, 88, 81, 0.1);
    em {
      display: grid;
    }
  }
`;

export const ListItemContent = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.matterHorn};
  padding: 8px 20px;
  display: flex;
  cursor: pointer;
  flex: 1;
  z-index: 99999;
  width: calc(100% - 40px);

  path {
    fill: inherit !important;
  }
`;

export const ItemText = styled.div`
  padding-left: 15px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: table-cell;
`;

export const StyledSearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
  align-items: end;
  margin-bottom: 10px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 17px 0 0 20px;
    align-items: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

export const Text = styled.span<{ color: PaletteColor }>`
  color: ${({ theme, color }) => theme.palette[color]};
  padding-left: 5px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding-left: 14px;
  }
  font-size: 14px;
  font-weight: bold;
`;

export const BookerSearchInputWrapper = styled.div<{ height?: number }>`
  max-height: 440px !important;
  overflow: auto !important;
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${({ theme }) => theme.palette.gray};
    border-radius: 10px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.brownishGrey};
    border-radius: 10px;
  }
  .react-tiny-popover-container {
    width: 570px !important;
    top: -25px !important;
    @media (max-width: ${LANDING_BREAKPOINT}) and (min-width: ${LARGE_SCREEN_BREAKPOINT}) {
      width: 500px !important;
    }
  }
`;

export const HotelSeachWrapper = styled.div<{
  cyprus?: boolean;
  borderRadius?: string;
}>`
  border-radius: ${({ borderRadius }) => borderRadius || '0'};
  .react-tiny-popover-container {
    width: ${({ cyprus }) => (cyprus ? '686px' : '510px')}!important;
    top: -10px !important;
  }
`;

export const ResponsiveListingSearchLocationContainer = styled.div`
  padding: 0 15px;
  background: ${({ theme }) => theme.palette.white};
  max-height: 78px;
`;

export const GuestWrapper = styled.div`
  width: 570px;
  height: 200px;
  position: absolute;
  z-index: 10;
  background: ${({ theme }) => theme.palette.white};
`;

export const GuestContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 20px 15px 20px;
  position: absolute;
  background: ${({ theme }) => theme.palette.white};
`;

export const ResponsiveSearchDrawerItemContainer = styled.div<{
  isBookerSearch?: boolean;
  isTravelPlanning?: boolean;
}>`
  max-width: 220px;
  height: 66px;
  border-radius: 8px;
  width: 100%;
  overflow: ${({ isTravelPlanning }) =>
    isTravelPlanning ? 'hidden' : 'visible'};
  position: relative;
  overflow: hidden;

  .react-tiny-popover-container {
    position: fixed !important;
    width: 372px !important;
  }
`;

export const ResponsiveListingSearchContainer = styled.div`
  padding: 0 15px;
  background: ${({ theme }) => theme.palette.white};
`;

export const AddRoomWrapper = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'unset')};
  cursor: pointer;
`;

export const ResponsiveSearchDrawerItemWrapper = styled.div`
  padding: 0 18px;
`;

export const ButtonsWrapper = styled.div`
  height: 70px;
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.white};
  align-items: center;
  padding: 0 20px;
  position: absolute;
  bottom: 0;
  z-index: 10;
  width: 100%;
  box-shadow: 0 10px 40px 0 rgba(58, 58, 58, 0.2);
`;

export const AddRoomText = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  padding-bottom: 5px;
`;
export const CheckboxContainer = styled.div<{
  justifyContent?: CSSProperties['justifyContent'];
}>`
  display: flex;
  flex-wrap: wrap;
  padding: 20px 20px 10px;
  justify-content: ${({ justifyContent = 'space-between' }) => justifyContent};
`;

export const LeftSection = styled.div`
  @media (max-width: 395px) {
    padding-bottom: 20px;
  }
`;

export const RightSection = styled.div``;
export const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.white};
  padding: 16px 0px 0px 12px;
  border-radius: 2px;
  button {
    height: 66px;
    width: 123px;
    font-weight: bold;
    font-size: 18px;
  }
`;
export const WhereToGoSearchContainer = styled.div`
  min-width: 720px;
  .react-tiny-popover-container {
    width: 720px !important;
    position: fixed !important;
  }
`;

export const MonthDateWrapper = styled.div`
  width: 100%;
  .react-tiny-popover-container {
    width: 492px !important;
    position: fixed !important;
    box-shadow: unset !important;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    background-color: ${({ theme }) => theme.palette.white};
    padding: 0 20px;
  }
`;
